// Suporte (chamado no Disk, atendido no Jira Service Management) só existe
// quando a org tem as envs do Jira configuradas no back. A navegação (sidebar
// e drawer mobile) lê o MESMO cache ["support-config"] que help-screen.tsx e
// assistant-screen.tsx já usam — daí a query key viver aqui, fora das três
// pontas, igual ao padrão de click-to-call-enabled.ts.
import { supportKeys, useSupportConfig } from "@/hooks/use-support";

// A chave agora mora em `supportKeys.config` (src/hooks/use-support.ts), junto
// com as do resto do domínio. O nome antigo continua exportado daqui — é o que
// este arquivo sempre ofereceu ao resto do front.
export const SUPPORT_CONFIG_QUERY_KEY = supportKeys.config;

// Falha ao consultar (ou ainda carregando) esconde o item — fail-closed,
// igual ao que help-screen.tsx e assistant-screen.tsx já fazem com
// `suporte.data?.enabled`.
export function useSupportEnabled(): boolean {
  // `retry: false` é a divergência desta ponta e é de propósito: item de menu
  // que some é melhor que menu que treme. As quatro telas do domínio usam o
  // default do cliente, na MESMA entrada de cache.
  const q = useSupportConfig({ retry: false });
  return q.data?.enabled ?? false;
}
